module.exports = __webpack_public_path__ + "img/sound_blocked.93f7a6bc.svg";